import PlanningStatusEnum from '../Enums/PlanningStatusEnum';

export default class RolloverItem {
  constructor(selectedItems) {
    this.PlanningDetailIds = selectedItems.map((item) => item.PlanningDetailId);
    // Only a Closed period can be rolled over. Offering the others as a source would just produce a
    // rejection on save, so the dropdown lists the Closed ones and everything else stays a target.
    const closedItems = selectedItems.filter((item) => item.Status === PlanningStatusEnum.Closed);
    this.SourceOptions = closedItems.map((item) => ({
      value: item.PlanningDetailId,
      label: `FW ${item.FieldworkOrderNumber} (${item.StartDate || '?'} – ${item.EndDate || '?'})`,
    }));
    this.SourcePlanningDetailId = closedItems.length ? closedItems[0].PlanningDetailId : null;
    this.DistributionType = 'even';
    this.Volume = 0;
    this.Items = selectedItems.map((item) => ({
      PlanningDetailId: item.PlanningDetailId,
      label: `FW ${item.FieldworkOrderNumber}`,
      rolloverValue: 0,
    }));
  }
}
